import { render, staticRenderFns } from "./PermissiveBtn.vue?vue&type=template&id=0456bf7d&"
import script from "./PermissiveBtn.vue?vue&type=script&lang=js&"
export * from "./PermissiveBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports